<template>
  <nav class="tabbar">
    <button :class="{ active: isActive('/') }" @click="go('/')" class="tab-item">
      <div class="tab-icon">🏠</div>
      <span class="tab-text">首页</span>
    </button>
    <button :class="{ active: isActive('/profile') }" @click="go('/profile')" class="tab-item">
      <div class="tab-icon">👤</div>
      <span class="tab-text">我的</span>
    </button>
    <!-- 调试信息 -->
    <!-- <div class="debug-info" v-if="showDebug">
      <small>{{ deviceType }} - {{ screenWidth }}px</small>
    </div>-->
  </nav>
</template>

<script>
export default {
  name: "TabbarMain",
  data() {
    return {
      localStorageData: {
        openid: localStorage.getItem("openid") || "",
        clientSessionKey: localStorage.getItem("clientSessionKey") || ""
      },
      showDebug: true // 启用调试信息
    };
  },
  mounted() {
    // 在 mounted 中重新获取，确保拿到最新值
    this.localStorageData = {
      openid: localStorage.getItem("openid") || "",
      clientSessionKey: localStorage.getItem("clientSessionKey") || ""
    };
  },
  computed: {
    deviceType() {
      const width = window.innerWidth;
      if (width <= 767) return "手机端";
      if (width <= 1023) return "平板端";
      return "桌面端";
    },
    screenWidth() {
      return window.innerWidth;
    }
  },
  methods: {
    go(path) {
      if (this.$route.path !== path) {
        if (path == "/") {
          this.$router.replace(
            path +
              "?openid=" +
              this.localStorageData.openid +
              "&clientSessionKey=" +
              this.localStorageData.clientSessionKey
          );
        } else {
          this.$router.replace(path);
        }
      }
    },
    isActive(path) {
      return this.$route.path === path;
    }
  }
};
</script>

<style scoped>
.tabbar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: 60px;
  border-top: 1px solid #e8e8e8;
  background: #fff;
  display: flex;
  z-index: 9999;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  width: 100%;
  /* 确保响应式生效 */
  transition: all 0.3s ease;
}

.tab-item {
  flex: 1;
  background: transparent;
  border: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 8px 4px;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
}

.tab-item:hover {
  background: rgba(64, 158, 255, 0.05);
}

.tab-item:active {
  transform: scale(0.95);
}

.tab-icon {
  font-size: 20px;
  margin-bottom: 4px;
  transition: all 0.3s ease;
}

.tab-text {
  font-size: 12px;
  font-weight: 500;
  color: #666;
  transition: all 0.3s ease;
}

.tab-item.active .tab-icon {
  transform: scale(1.1);
}

.tab-item.active .tab-text {
  color: #409eff;
  font-weight: 600;
}

/* 调试信息样式 */
.debug-info {
  position: absolute;
  top: -25px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 10px;
  z-index: 10000;
  white-space: nowrap;
}

/* 手机端响应式样式 */
@media (max-width: 767px) {
  .tabbar {
    box-shadow: 0 -1px 8px rgba(0, 0, 0, 0.08) !important;
    /* 适配iPhone X系列的安全区域 */
    padding-bottom: env(safe-area-inset-bottom) !important;
    height: calc(56px + env(safe-area-inset-bottom)) !important;
    width: 100% !important;
    left: 0 !important;
    right: 0 !important;
    transform: none !important;
    margin: 0 !important;
    max-width: none !important;
  }

  .tab-item {
    padding: 6px 2px;
  }

  .tab-icon {
    font-size: 18px;
    margin-bottom: 2px;
  }

  .tab-text {
    font-size: 11px;
  }
}

/* 平板端响应式样式 */
@media (min-width: 768px) and (max-width: 1023px) {
  .tabbar {
    height: 64px !important;
    max-width: 768px !important;
    left: 50% !important;
    right: auto !important;
    transform: translateX(-50%) !important;
    border-radius: 0 !important;
    margin: 0 !important;
    width: 100% !important;
  }

  .tab-item {
    padding: 10px 8px;
  }

  .tab-icon {
    font-size: 22px;
    margin-bottom: 6px;
  }

  .tab-text {
    font-size: 13px;
  }
}

/* 桌面端响应式样式 */
@media (min-width: 1024px) {
  .tabbar {
    height: 70px !important;
    max-width: 1200px !important;
    left: 49.6% !important;
    right: auto !important;
    transform: translateX(-50%) !important;
    border-radius: 0 !important;
    margin: 0 !important;
    box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.15) !important;
    width: 100% !important;
  }

  .tab-item {
    padding: 12px 12px;
  }

  .tab-icon {
    font-size: 24px;
    margin-bottom: 8px;
  }

  .tab-text {
    font-size: 14px;
  }

  .tab-item:hover {
    background: rgba(64, 158, 255, 0.08);
  }
}

/* 横屏适配 */
@media (orientation: landscape) and (max-height: 500px) {
  .tabbar {
    height: 50px;
  }

  .tab-item {
    padding: 4px 2px;
  }

  .tab-icon {
    font-size: 16px;
    margin-bottom: 1px;
  }

  .tab-text {
    font-size: 10px;
  }
}

/* 高分辨率屏幕适配 */
@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
  .tabbar {
    border-top-width: 0.5px;
  }
}

/* 暗色模式支持 */
@media (prefers-color-scheme: dark) {
  .tabbar {
    background: #1a1a1a;
    border-top-color: #333;
  }

  .tab-text {
    color: #ccc;
  }

  .tab-item.active .tab-text {
    color: #409eff;
  }

  .tab-item:hover {
    background: rgba(64, 158, 255, 0.1);
  }
}

/* 动画效果 */
.tab-item {
  position: relative;
  overflow: hidden;
}

.tab-item::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    45deg,
    transparent 30%,
    rgba(64, 158, 255, 0.1) 50%,
    transparent 70%
  );
  transform: translateX(-100%);
  transition: transform 0.6s ease;
}

.tab-item:active::before {
  transform: translateX(100%);
}

/* 无障碍支持 */
.tab-item:focus {
  outline: 2px solid #409eff;
  outline-offset: 2px;
}

.tab-item:focus:not(:focus-visible) {
  outline: none;
}

/* 触摸设备优化 */
@media (hover: none) and (pointer: coarse) {
  .tab-item {
    min-height: 44px; /* iOS推荐的最小触摸目标 */
  }

  .tab-item:active {
    background: rgba(64, 158, 255, 0.1);
    transform: scale(0.98);
  }
}
</style>


